// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useEffect, useRef, useState, } from 'react';
import { Icon } from '../icon/index.js';
import { Input, inputClassName } from '../input/index.js';
export function EditableText(_a) {
    var { value, onValueChange, editing, onEditingChange, className, id, autoSelect, autoFocus, onBlur, onChange, onKeyDown } = _a, rest = __rest(_a, ["value", "onValueChange", "editing", "onEditingChange", "className", "id", "autoSelect", "autoFocus", "onBlur", "onChange", "onKeyDown"]);
    const [editingInternal, setEditingInternal] = useState(editing || autoFocus);
    const editingFinal = editing !== null && editing !== void 0 ? editing : editingInternal;
    const setEditingFinal = onEditingChange !== null && onEditingChange !== void 0 ? onEditingChange : setEditingInternal;
    const handleChange = useCallback((ev) => {
        onValueChange(ev.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(ev);
    }, [onValueChange, onChange]);
    const handleKeyDown = useCallback((ev) => {
        if (ev.key === 'Enter') {
            setEditingFinal(false);
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(ev);
    }, [setEditingFinal, onKeyDown]);
    const inputRef = useRef(null);
    useEffect(() => {
        if (editingFinal && inputRef.current) {
            // -10... roughly estimated based on default font.
            inputRef.current.size = Math.max(1, value.length - 5);
            inputRef.current.focus();
        }
    }, [editingFinal, inputRef]);
    const handleBlur = useCallback((ev) => {
        setEditingFinal(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(ev);
    }, [setEditingFinal, onBlur]);
    if (editingFinal) {
        return (_jsx(Input, Object.assign({ ref: inputRef, value: value, onChange: handleChange, onBlur: handleBlur, className: clsx('layer-variants:font-size-inherit', className), id: id, autoSelect: autoSelect, onKeyDown: handleKeyDown }, rest)));
    }
    return (_jsxs("button", Object.assign({ onClick: () => setEditingFinal(true), className: clsx(inputClassName, 'layer-variants:border-transparent layer-variants:bg-transparent layer-variants:w-auto layer-variants:inline-flex layer-variants:items-center layer-variants:gap-2 layer-variants:font-size-inherit layer-variants:color-inherit layer-variants:shadow-none layer-variants:text-left', 'layer-variants:hover:bg-gray-blend', 'layer-variants:focus-visible:outline-none layer-variants:focus-visible:bg-gray-dark-blend', 'cursor-pointer', className), id: id }, rest, { children: [value, _jsx(Icon, { name: "pencil", className: "stroke-gray-blend opacity-50" })] })));
}
//# sourceMappingURL=EditableText.js.map